module.exports = __webpack_public_path__ + "img/folder.dc1dce9f.svg";